"use client";

import React, { useState } from "react";
import Link from "next/link";
import { X, Calendar, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AnnouncementBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-blue-600 via-blue-500 to-purple-800 text-white py-1 px-4 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-black/10" />

      <div className="container mx-auto relative z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <Calendar className="h-5 w-5 text-white/90 flex-shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm md:text-base font-medium truncate">
                <span className="hidden sm:inline">🚀 New Webinar: </span>
                <span className="font-semibold">
                  How SMEs Can Leverage AI in 2025
                </span>
                <span className="hidden md:inline">
                  {" "}
                  - Join the waitlist now!
                </span>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 ml-4">
            <Button
              asChild
              size="sm"
              className="bg-white text-blue-600 hover:bg-white/90 font-semibold shadow-lg"
            >
              <Link href="/events" className="flex items-center gap-1">
                <span className="hidden sm:inline">Join Waitlist</span>
                <span className="sm:hidden">Join</span>
                <ArrowRight className="h-3 w-3" />
              </Link>
            </Button>

            <button
              onClick={() => setIsVisible(false)}
              className="p-1 hover:bg-white/20 rounded transition-colors"
              aria-label="Close banner"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
